import type { FC } from 'react';
import React from 'react';

import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { Image } from '@sravni/react-image';

import { useUserPromoContent } from '@src/reducers/promo';
import { augustPromoPdfRoute } from '@src/shared/constants/pageRoutes';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';

import promoCoins from './assets/promoCoins.png';
import styles from './PromoGuideSheet.module.scss';
import { getMobileAppPromoSheetTexts } from './PromoGuideSheet.texts';

type MobileAppPromoSheetProps = {
  visible: boolean;
  link: string;
  source: string;

  onClose: (event: React.MouseEvent | KeyboardEvent | PopStateEvent) => void;
};

export const PromoGuideSheet: FC<MobileAppPromoSheetProps> = ({ visible, link, source, onClose }) => {
  const { bonusAmount, startDate, endDate } = useUserPromoContent();

  const texts = getMobileAppPromoSheetTexts(bonusAmount, startDate, endDate);

  return (
    <Sheet visible={visible} onClose={onClose}>
      <Sheet.Header
        className={styles.header}
        title={
          <Space size={[16, 16]} direction="vertical" align="center">
            <Image src={promoCoins} alt={texts.title} width={240} height={120} />
            <Heading level={3} size={28}>
              {texts.title}
            </Heading>
          </Space>
        }
      />

      <Sheet.Content className={styles.content}>
        <Text className="h-color-D100" size={16}>
          {texts.description}
        </Text>

        <div className={styles.info}>
          <Text className="h-color-D100" size={14}>
            {texts.info}
          </Text>
          <Text className="h-color-D100" size={14}>
            {texts.info2}
          </Text>

          <Link className={styles.link} href={augustPromoPdfRoute} target="_blank" rel="noopener noreferrer">
            {texts.linkText}
          </Link>
        </div>
      </Sheet.Content>

      <Sheet.Footer className={styles.footer}>
        <ToFullDealAdvertisingButton size={52} block variant="primary" color="dark" link={link} source={source}>
          {texts.buttonText}
        </ToFullDealAdvertisingButton>
      </Sheet.Footer>
    </Sheet>
  );
};
